import { useEffect, useState } from "react";
import { agencyApi } from "./agencyApi";
import { WorkThumb, WorkViewer } from "./WorkViewer";
import "./agency.css";

// Archives — Agency Portal PM Feedback Batch 2, item 3 (2026-09). Browses NJM's canonical
// Video Links Master Library, restricted server-side to items an NJM staffer has explicitly
// flagged "Agency visible" (default OFF — see modules/videos.py::set_video_agency_visibility).
// Read-only browsing here; attaching one as a reference lives in the Estimator (Step 2).
export default function AgencyArchives() {
  const [items, setItems] = useState([]);
  const [categories, setCategories] = useState([]);
  const [category, setCategory] = useState("");
  const [loading, setLoading] = useState(true);
  const [viewing, setViewing] = useState(null);

  useEffect(() => {
    setLoading(true);
    agencyApi.archives(category || undefined).then((r) => {
      setItems(r.data.items || []);
      setCategories(r.data.categories || []);
    }).catch(() => {}).finally(() => setLoading(false));
  }, [category]);

  return (
    <div data-testid="agency-archives-page">
      <h1 className="ag-h1" data-testid="agency-archives-title">Archives</h1>
      <p className="ag-body" style={{ marginTop: 10, marginBottom: 22 }}>Selected work from NJM's library — browse for inspiration, or attach up to 5 as references when you request a quote.</p>

      {categories.length > 0 && (
        <div className="ag-est-chips" style={{ marginBottom: 20 }} data-testid="agency-archives-category-filter">
          <button type="button" className={`ag-est-chip${category === "" ? " active" : ""}`} onClick={() => setCategory("")} data-testid="agency-archives-category-all">All</button>
          {categories.map((c) => (
            <button key={c} type="button" className={`ag-est-chip${category === c ? " active" : ""}`} onClick={() => setCategory(c)} data-testid={`agency-archives-category-${c.toLowerCase().replace(/\s+/g, "-")}`}>{c}</button>
          ))}
        </div>
      )}

      {loading ? (
        <p className="ag-small" data-testid="agency-archives-loading">Loading…</p>
      ) : items.length === 0 ? (
        <div className="ag-card" data-testid="agency-archives-empty">
          <p className="ag-body">Nothing here yet. Check back soon — NJM curates this library over time.</p>
        </div>
      ) : (
        <div style={{ display: "flex", flexWrap: "wrap", gap: 20 }} data-testid="agency-archives-grid">
          {items.map((it) => (
            <div key={it.id} style={{ width: 180 }} data-testid={`agency-archives-item-${it.id}`}>
              <WorkThumb sample={{ ...it, role_tag: it.category }} onOpen={setViewing} label={it.title} width={180} height={110} />
            </div>
          ))}
        </div>
      )}

      {viewing && <WorkViewer sample={viewing} onClose={() => setViewing(null)} />}
    </div>
  );
}
